class VideoCarousel extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target.closest("button[data-idx]");
      if (!button) return;

      const slide = button.closest(".video-slide");
      if (!slide) return;

      const info = slide.querySelector(".info");
      const video = slide.querySelector("video");

      const isVisible = !info.classList.contains("hidden");

      this.querySelectorAll(".video-slide").forEach((otherSlide) => {
        if (otherSlide === slide) return;

        const otherInfo = otherSlide.querySelector(".info");
        const otherVideo = otherSlide.querySelector("video");
        const otherButton = otherSlide.querySelector("button[data-idx]");

        if (otherInfo) otherInfo.classList.add("hidden");
        if (otherVideo) {
          otherVideo.classList.add("opacity-0");
          otherVideo.classList.remove("opacity-100");
          otherVideo.pause();
        }
        if (otherButton) {
          otherButton.style.transform = "rotate(0deg)";
        }
      });

      info.classList.toggle("hidden", isVisible);

      if (video) {
        video.classList.toggle("opacity-0", isVisible);
        video.classList.toggle("opacity-100", !isVisible);

        if (!isVisible) {
          if (video.ended || video.currentTime === video.duration) {
            video.currentTime = 0;
          }
          video.play();
        } else {
          video.pause();
        }
      }

      button.style.transform = isVisible ? "rotate(0deg)" : "rotate(45deg)";
    });
  }
}

customElements.define("video-carousel", VideoCarousel);
